<template>
	
	<div class="comment-box card card--shadow card--no-padding card--no-input-border">
		
		<el-button class="comment-box__button comment-box__add-button" type="warning" size="mini" icon="el-icon-check" :disabled="comment === ''" :loading="$store.getters.loading" @click="onClickAddComment" circle></el-button>
		
		<emoji-picker @emoji="onClickAddEmoji" :search="emoji.search">
			
			<div class="emoji-invoker" slot="emoji-invoker" <div slot="emoji-invoker" slot-scope="{ events: { click: clickEvent } }" @click.stop="clickEvent">
				<el-button class="comment-box__button comment-box__emoji-button" type="text" size="mini" circle>
					<ion-icon name="happy"></ion-icon>
				</el-button>
			</div>
			
			<div slot="emoji-picker" slot-scope="{ emojis, insert, display }">
				<div class="emoji-picker card card--shadow card--shadow-large" :style="{ 'top': '88px', 'right': '-8px' }">
					<input class="emoji-picker__search el-input" type="text" v-model="emoji.search" placeholder="Search emojis">
					<div v-for="(emojiGroup, category) in emojis" :key="category">
						<h5>{{ category }}</h5>
						<div class="emojis">
							<span v-for="(emoji, emojiName) in emojiGroup" :key="emojiName" @click="insert(emoji)" :title="emojiName">{{ emoji }}</span>
						</div>
					</div>
				</div>
			</div>
			
		</emoji-picker>
		
		<el-input class="comment-box__text-input" type="textarea" :rows="3" :placeholder="hintText" v-model="comment" ref="commentTextInput"></el-input>
		
	</div>
	
</template>

<script>
	
	import EmojiPicker from "vue-emoji-picker";
	
	export default {
		
		components: { EmojiPicker },
		
		props: {
			
			hintText: {
				type: String,
				default: "What do you want to say?",
			}
			
		},
		
		methods: {
			
			onClickAddComment() {
				this.$emit("on-add", this.comment);
				this.comment = "";
			},
			
			onClickAddEmoji(emoji) {
				
				const textarea = this.$refs.commentTextInput.$el.children[0];
				
				const startPos = textarea.selectionStart;
				const endPos = textarea.selectionEnd;
				const tmpStr = textarea.value;
				const insert = emoji;
				
				let cursorPos = startPos;
				
				this.comment = tmpStr.substring(0, startPos) + insert + tmpStr.substring(endPos, tmpStr.length);
				
				setTimeout(() => {
					cursorPos += insert.length;
					textarea.selectionStart = textarea.selectionEnd = cursorPos;
				}, 10);
				
			},
			
		},
		
		data() {
			
			return {
				
				comment: "",
				
				emoji: {
					search: "",
				}
				
			}
			
		}
		
	}
	
</script>

<style lang="scss" scoped>
	
	/*.comment-box {
		position: relative;
	}

	.comment-box__text-input {
		
		width: 100%;
		padding-right: 44px;
		box-sizing: border-box;
		
		.el-textarea {
			width: auto;
		}
		
		.el-textarea__inner {
			padding-right: 64px !important;
		}
		
	}

	.comment-box__button {
		position: absolute !important;
	}

	.comment-box__add-button {
		float: right;
		top: 15px;
		right: 10px;
	}

	.comment-box__emoji-button {
		top: 50px;
		right: 10px;
		padding: 2px;
		ion-icon {
			font-size: 24px;
			margin: 0;
		}
	}

	.comment-box__description {
		white-space: pre-line;
	}

	.emoji-picker {
		position: absolute;
		z-index: 1000;
		overflow: scroll;
		padding: 10px;
		box-sizing: border-box;
		height: 320px;
		width: 320px;
		overflow: auto;
	}

	.emoji-picker__search {
		border-radius: 4px;
		border: 1px solid rgba(0, 0, 0, 0.1);
		padding: 10px 15px;
		outline: none;
		margin-bottom: 10px;
		width: 100%;
		box-sizing: border-box;
	}

	.emoji-picker h5 {
		color: #b1b1b1;
		cursor: default;
		margin-bottom: 10px;
	}

	.emoji-picker .emojis {
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
		margin-bottom: 10px;
	}

	.emoji-picker .emojis:after {
		content: "";
		flex: auto;
	}

	.emoji-picker .emojis span {
		padding: 0.2rem;
		cursor: pointer;
		border-radius: 5px;
	}

	.emoji-picker .emojis span:hover {
		background: #ececec;
		cursor: pointer;
	}*/
	
</style>


// WEBPACK FOOTER //
// src/components/Comments/CommentBox.vue